// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ta7A","item":"PaymentsMobile_item__3VbIU","label":"PaymentsMobile_label__33bjV","amount":"PaymentsMobile_amount__3veOr"};